/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

export type SectionResponseDtoSection = (typeof SectionResponseDtoSection)[keyof typeof SectionResponseDtoSection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SectionResponseDtoSection = {
  OPEN_POSITIONS: 'OPEN_POSITIONS',
  HISTORY: 'HISTORY',
  ORDER_BOOK: 'ORDER_BOOK',
  MARKET_RULES: 'MARKET_RULES',
  TRENDING: 'TRENDING',
  COMMENTS: 'COMMENTS',
  OPEN_ORDERS: 'OPEN_ORDERS',
  RESULT: 'RESULT',
} as const;
